exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_companyInformation_xI4J01rd8Gl2SH-e-dQ2L {\n  width: 100%;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_divider_3LYT_COa0BNRpD-AktyHPK, .IA_dividerDarkMode_1PpIxXzvsaxCXoIJJvK9M- {\n  height: 1px;\n  width: 100%;\n  background-color: #eeeeee;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_billingInfo_3RA6h5WKSyv81Fu0kWFHPG {\n  font-size: 14px;\n}", ""]);

// Exports
exports.locals = {
	"IA_companyInformation": "IA_companyInformation_xI4J01rd8Gl2SH-e-dQ2L",
	"IA_divider": "IA_divider_3LYT_COa0BNRpD-AktyHPK",
	"IA_dividerDarkMode": "IA_dividerDarkMode_1PpIxXzvsaxCXoIJJvK9M-",
	"IA_billingInfo": "IA_billingInfo_3RA6h5WKSyv81Fu0kWFHPG"
};